export default __webpack_public_path__ + "static/media/background_start.c0de3bd7.jpg";